var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBearIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42.799mm",
    height: "40.17mm",
    viewBox: "0 0 161.76 151.82",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 162,
    height: 152
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.00068237)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.021)",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m161.44 27.41c-0.5-1.95-1-3.92-1.6-5.82-1.69-5.06-3.47-10.09-6.52-14.52-4.68-6.78-11.61-8.77-19.2-5.59-4.1093 1.7835-7.7306 4.527-10.56 8-1.7594 2.2792-4.6825 3.329-7.49 2.69-1.1999-0.28212-2.3384-0.78024-3.36-1.47-7.65-4.93-15.9-7.38-25-6.3-4.2167 0.56257-8.4881 0.58273-12.71 0.06-2.6217-0.30843-5.2665-0.37204-7.9-0.19-6.56 0.37-12.43 2.85-17.92 6.35-4.32 2.75-7.93 2.21-11.3-1.57-0.85378-0.97082-1.7654-1.8892-2.73-2.75-4.1-3.61-8.68-6.15-14.45-6.3-0.65 0.06-1.42 0.08-2.19 0.22-5.28 0.92-8.73 4.29-11.23 8.78-3.0713 5.5599-5.3533 11.52-6.78 17.71-0.41832 1.4369-0.56417 2.9394-0.43 4.43 0.84 5.52 4.3 9.4 8.58 12.6 3.62 2.69 4.62 6.2 2.78 10.33-1.1327 2.4346-2.1341 4.9282-3 7.47-4.26 13.03-3.87 25.46 4.4 37.09 9.77 13.78 20.89 26.18 35.37 35 10.45 6.39 21.31 12.1 32 18.07 0.49195 0.18836 1.0407 0.15929 1.51-0.08 7-3.82 14-7.77 21.12-11.5 20.07-10.58 35.93-25.65 48.13-44.7 3.3497-5.4036 5.107-11.643 5.07-18 0.16-8.35-2.24-16.11-5.75-23.6-1.8642-3.53-0.67533-7.9006 2.72-10 3.01-2.1339 5.4875-4.9331 7.24-8.18 1.4902-2.4704 1.9227-5.4369 1.2-8.23z",
    fill: "current",
    "data-name": "Trazado 1041"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBearIcon);
export default __webpack_public_path__ + "static/media/BearIcon.2949a50666a1ff8db088015453faf5e4.svg";
export { ForwardRef as ReactComponent };